export interface JobStatusFilterOption {
  label: string;
  value: string;
}

export const DEFAULT_JOB_STATUS_FILTER = 'In-progress';
export const ALL_JOB_STATUS = 'All job statuses';
export const ACTIVE_JOB_STATUS = 'Active';
export const INACTIVE_JOB_STATUS = 'Inactive';
export const PUBLISHED_JOB_STATUS = 'Published';

export enum JobStatusEnum {
  New = 'New',
  Progress = 'In-progress',
  MSP_Pipeline = 'MSP Pipeline',
  Waiting = 'Waiting on approval',
  Filled_Internal = 'Filled-internal',
  Filled_External = 'Filled-external',
  OnHold = 'On-hold',
  Canceled = 'Canceled',
  Published = 'Published',
}

export const ALL_JOB_STATUSES_FILTER_OPTIONS: JobStatusFilterOption[] = [
  { label: ALL_JOB_STATUS, value: ALL_JOB_STATUS },
  { label: JobStatusEnum.New, value: JobStatusEnum.New },
  { label: DEFAULT_JOB_STATUS_FILTER, value: JobStatusEnum.Progress },
  { label: JobStatusEnum.MSP_Pipeline, value: JobStatusEnum.MSP_Pipeline },
  { label: JobStatusEnum.Waiting, value: JobStatusEnum.Waiting },
  { label: JobStatusEnum.Filled_Internal, value: JobStatusEnum.Filled_Internal },
  { label: JobStatusEnum.Filled_External, value: JobStatusEnum.Filled_External },
  { label: JobStatusEnum.OnHold, value: JobStatusEnum.OnHold },
  { label: JobStatusEnum.Canceled, value: JobStatusEnum.Canceled },
];

export const BASIC_JOB_STATUSES_FILTER_OPTIONS: JobStatusFilterOption[] = [
  { label: ALL_JOB_STATUS, value: ALL_JOB_STATUS },
  { label: ACTIVE_JOB_STATUS, value: JobStatusEnum.Progress },
  { label: INACTIVE_JOB_STATUS, value: JobStatusEnum.Canceled },
];

export const PUBLISHED_JOB_STATUSES: JobStatusFilterOption[] = [
  { label: PUBLISHED_JOB_STATUS, value: JobStatusEnum.Published },
  { label: ACTIVE_JOB_STATUS, value: JobStatusEnum.Progress },
];
